import useCurrentVault from '@app/Areas/Optimus/State/DataStores/VaultStore/hooks/useCurrentVault';

function useCurrentVaultId() {
    const currentVault = useCurrentVault();
    return currentVault?.id;
}

export default useCurrentVaultId;
